export const vendorEndPoint =
  'https://ss.seasonshare.co/api/vendors/ticketmaster/seasonPreview';
export const eventEndPoint = '/event';
export const customerEndPoint = '/teamAuth';
export const eventSeatEndPoint = '/inventory';
export const authEndPoint = '/admin';
export const transactionEndPoint = '/transactions';
export const customerHistoryEndpoint = '/transactions/customer';
